import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: true,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'blueprint', 'sg-digital', 'relax'],
        'live-casino': ['evolution', 'pragmatic', 'ezugi'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: false,
    decimalLength: 2,
    depositLimitType: 'calendarType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'This site is owned by DragonBet and is operated by Playbook Gaming Ltd (10889074), trading as Playbook Engineering Ltd, (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. No.1 Poultry, London EC2R 8EJ.',
        licence_number: '50122',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/50122',
        cookies_url: 'https://dragonbet.co.uk/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-PN3XBZ7Z',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: {
        host: 'dragonbet.co.uk',
        key: '3a4785049a28487b9a07fce395b51a5d',
    },

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
        {
            value: 'wls',
            label: 'Welsh',
        },
    ],

    /* O */
    operatorFullName: 'DragonBet', // TODO Please verify

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    redirectToNewTradingPage: false,
    reportsV2: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'DragonBet Events', // TODO dragonbet
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: true,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtNDQyNzk0OkItcDEtMC02NjhmYjZmMy0wLTMwMmMwMjE0NzZmYjBhNzk2M2NiMjFlYjU1MTU4NzMwNGJjNThkMTYyNGIwOTBmMjAyMTQyMTEzOTNjNTNkNDk1NDVkMWNiYzVjMzRhNDMwODZlMGUzNjZmNTM3',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003346754',
            EUR: '',
        },
        openBanking: null,
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        Accounts: 'Accounts-Dragonbet/Overview',
        BackofficeReports: 'BackOfficeReports-Dragonbet/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-Dragonbet/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-Dragonbet/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-Dragonbet/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-Dragonbet/DailyKPI',
        RacecourseDashboard: 'Racecourse-Dragonbet/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-Dragonbet/TransactionsMainDashboard',
        SRGDashboard: 'SRGDashboard-Dragonbet/DBAverageStakes',
        AccountBalances: 'AccountBalances-Dragonbet/AccountBalances',
        RollingNetDeposits: 'RollingNetDeposits-Dragonbet/RollingNetDeposits',
        LiveChat: 'LiveChat-Dragonbet/LiveChatDashboard',
        TargetingAttributes: 'TargetingAttributes-Dragonbet/ValueTiering',
        BonusEngine: 'BonusEngine-Dragonbet/CampaignLevel',
        PromoPrediction: 'PromoPrediction-Dragonbet/SinglePromoAnalysis',
        SymplifyDashboard: 'SymplifyCampaignData-Dragonbet/CampaignDataDashboard',
    },
};
